<template>
  <div class="flex-center position-ref">
    <div class="content">
      <Loading :loading="loading"></Loading>
      <img src="/assets/logos/gradingly.png" alt="" />
      <SsoError v-if="error" :message="error"></SsoError>
      <h3 v-else-if="this.$route.query.sso">Lütfen bekleyiniz, ilgili platforma yönlendiriliyorsunuz.</h3>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import CryptoJS from "crypto-js";
import Loading from "@/components/Loading.vue";
import SsoError from "@/components/SsoError.vue";
import { serviceApiBaseUrl } from "@/config/serviceApi";

/**
 * Gradingly SSO launch — UES-Gradingly-SSO-Launch-Brief.docx'teki akış.
 *
 * `sso` parametresi burada (tarayıcıda) çözülür — bu adım her platformda aynı ve
 * hassas değil. Ama UES'e kullanıcı doğrulatma/oluşturma ve launch JWT'sinin
 * imzalanması artık tarayıcıdan yapılmıyor: service-api-ueslms'in tek uçlu
 * `/sso/gradingly/resolve`'una taşındı (k12net'teki aynı gerekçeyle — bkz.
 * K12Net.vue, ueslms/app/Http/Middleware/VerifyPlatformSignature.php). JWT imzalama
 * sırrı da ueslms'de (GradinglyController) kalır; ne bu bileşende ne
 * service-api-ueslms'te hiç bulunmaz.
 */
export default {
  name: "Gradingly",
  components: {Loading, SsoError},
  data() {
    return {
      loading: false,
      // service.ueslms.com -> Gradingly SSO girişinde `sso` parametresini çözmek için kullanılan AES anahtarı.
      secretKey: '2716c9%bc44dda8829.2022a48841eb34!4cc301b23+f79b7a5f5-8f7f4741a!',
      launchUrl: 'https://ues-oidc.onrender.com/launch',
      userData: null,
      error: null,
    }
  },
  beforeMount() {
    const query = this.$route.query;
    if (!query.sso) {
      return;
    }

    this.loading = true;

    let userData;
    try {
      // gelen data çözülüyor
      const decode = decodeURIComponent(atob(query.sso));
      const bytes = CryptoJS.AES.decrypt(decode, this.secretKey).toString(CryptoJS.enc.Utf8);
      userData = JSON.parse(bytes);
    } catch (e) {
      this.fail('Gelen bağlantı okunamadı. Lütfen Gradingly girişini UES üzerinden tekrar başlatın.');
      return;
    }

    this.userData = userData;
    this.resolve();
  },
  methods: {
    fail(message) {
      this.loading = false;
      this.error = message;
      console.log('Gradingly SSO:', message);
    },

    async resolve() {
      try {
        const response = await axios.post(`${serviceApiBaseUrl}/sso/gradingly/resolve`, {
          user: this.userData,
        }, { timeout: 60000 });

        const data = response.data;
        if (!data || !data.success || !data.launch_token) {
          this.fail((data && data.message) || 'Kullanıcı bilgileri alınamadı. Lütfen tekrar deneyin.');
          return;
        }

        window.location.href = `${this.launchUrl}?ues_token=${data.launch_token}`;
      } catch (error) {
        const message = error.response && error.response.data && error.response.data.message;
        this.fail(message || 'Bağlantı kurulamadı. Lütfen tekrar deneyin.');
      }
    },
  },
}
</script>

